import React, { type ReactNode, type MouseEvent } from 'react';
import Button from '@atlaskit/button';
import { Inline } from '@atlaskit/primitives';
import { fg } from '@atlassian/jira-feature-gating';
import { useIntl } from '@atlassian/jira-intl';
import { useRouterPush } from '@atlassian/jira-servicedesk-customer-service-common/src/utils/use-router-push/index.tsx';
import type { UserPermissions } from '../../controllers/app-store/types.tsx';
import { getMessageBasedOnUserPermissionsNew } from './utils.tsx';

type AccessMessageProps = {
	isProjectSimplified: boolean;
	baseUrl: string;
	projectKey: string;
	userPermissions?: UserPermissions;
};

export const AccessMessage = ({
	baseUrl,
	projectKey,
	isProjectSimplified,
	// @ts-expect-error - TS2740 - Type '{}' is missing the following properties from type 'UserPermissions': customerRoleMisconfigured, canAdminister, canAdministerJIRA, outgoingMailConfigured, and 7 more.
	userPermissions = {},
}: AccessMessageProps) => {
	const { formatMessage } = useIntl();
	const { push } = useRouterPush();
	const { canAdminister } = userPermissions;

	if (!canAdminister) {
		return null;
	}

	const customerPermissionUrl =
		isProjectSimplified && !fg('update_jsm_project_settings_pages_urls')
			? `${baseUrl}/jira/servicedesk/projects/${projectKey}/settings/channels/customer-permissions`
			: `${baseUrl}/jira/servicedesk/projects/${projectKey}/settings/customer-permissions`;

	const message = getMessageBasedOnUserPermissionsNew(userPermissions);

	const onClick = (event: MouseEvent<HTMLElement>) => {
		push(event, customerPermissionUrl);
	};

	return (
		<Inline space="space.025">
			{formatMessage(message, {
				a: (children: ReactNode) => (
					<Button appearance="link" href={customerPermissionUrl} spacing="none" onClick={onClick}>
						{children}
					</Button>
				),
			})}
		</Inline>
	);
};
